import axios from "axios";
import global from "@/global/variable.js";

// 获取记录
export function getList(data) {
  const url = global.requestUrl + "/oilInStock/queryPage";
  return axios.post(url, data);
}
// 获取记录
export function getOilInStockPage(data) {
  const url = global.requestUrl + "/oilInStock/oilInStockPage";
  return axios.post(url, data);
}
export function add(data) {
  const url = global.requestUrl + "/oilInStock/addInStock";
  return axios.post(url, data);
}
export function update(data) {
  const url = global.requestUrl + "/oilInStock/updateInStock";
  return axios.post(url, data);
}

// 删除
export function del(data) {
  const url = global.requestUrl + "/oilInStock/deleteRecordById/" + data.id;
  return axios.get(url, data);
}
